module.exports = __webpack_public_path__ + "assets/img/22_268.6441e137.jpg";